import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, ResetPasswordRequest } from 'types';
import { client } from 'utils/api-client';

export default function useResetPassword(): UseMutationResult<
  AxiosResponse<void>,
  AxiosError<ErrorMessage>,
  ResetPasswordRequest
> {
  const resetPassword = (request: ResetPasswordRequest): Promise<AxiosResponse<void>> => {
    return client.post('/auth/reset-password/', request);
  };

  return useMutation(resetPassword);
}
